import { Map } from 'immutable';
import { camelizeKeys } from 'humps';

import {
  CONDITIONS__CREATE,
  CONDITIONS__FETCH,
  ELEMENTS__DELETE,
  PAGES__DELETE,
  RULES__CREATE,
  RULES__DELETE,
  // RULES__PATCH,
  // RULES__REPLACE,
  RULES__UPDATE,
  SURVEY_EDITOR__RESET,
  USER__LOG_OFF,
} from '../constants';

export const defaultState = new Map({});

const resolveRule = (state, rule) => state.merge({ [rule.id]: camelizeKeys(rule) });

const resolveCondition = (state, condition) =>
  condition.rules.reduce((newState, rule) => resolveRule(newState, rule), state);

const resolveConditionsArray = (state, conditions) =>
  conditions.reduce((newState, condition) => resolveCondition(newState, condition), state);

const removeRulesByElementId = (state, elementId) =>
  state.filter((rule) => rule.get('elementId') !== elementId);

const handleDeletePage = (state, { data }) => {
  const elementIds = data.reduce((acc, { children }) => [...acc, children.map(({ id }) => id)], []);
  return state.filter((rule) => {
    const ruleId = rule.get('id');
    return elementIds.includes(ruleId);
  });
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case CONDITIONS__CREATE:
    case RULES__UPDATE:
    case RULES__CREATE:
      return resolveCondition(state, action.data);
    case CONDITIONS__FETCH:
      return resolveConditionsArray(state, action.data);
    case ELEMENTS__DELETE:
      return removeRulesByElementId(state, action.elementId);
    case PAGES__DELETE:
      return handleDeletePage(state, action);
    case RULES__DELETE:
      return state.delete(action.ruleId);
    case SURVEY_EDITOR__RESET:
    case USER__LOG_OFF:
      return defaultState;
    default:
      return state;
  }
};
